export default "__VITE_ASSET__789a8fdb__"